const ROUTE_PATTERNS = [
  {
    match: ["royal parade", "city centre", "mayflower", "armada", "bretonside", "drake circus", "derry", "station", "north hill", "union street"],
    services: [
      { route: "21/21A", dest: "Plympton / Barne Barton", via: "City Centre and Marsh Mills" },
      { route: "42/42C", dest: "Derriford / Woolwell", via: "Mutley and Crownhill" },
      { route: "5/5A", dest: "Elburton", via: "Prince Rock and Plymstock" },
      { route: "34", dest: "Derriford / Royal William Yard", via: "Stoke and Milehouse" },
      { route: "50/51", dest: "Derriford circular", via: "Estover and Transit Way" },
    ],
  },
  {
    match: ["plympton", "chaddlewood", "woodford", "marsh mills", "lee mill", "ivybridge", "ridgeway"],
    services: [
      { route: "21/21A", dest: "City Centre / Barne Barton", via: "Marsh Mills and Prince Rock" },
      { route: "20/20A", dest: "Royal Parade / Ivybridge", via: "Marsh Mills" },
      { route: "50/51", dest: "Derriford circular", via: "Leigham and Estover" },
    ],
  },
  {
    match: ["plymstock", "elburton", "pomphlett", "billacombe", "staddiscombe", "hooe", "wembury", "mount batten", "goosewell", "broadway"],
    services: [
      { route: "5/5A", dest: "City Centre / Elburton", via: "Prince Rock and Broadway" },
      { route: "48", dest: "Wembury / Plymouth", via: "Plymstock and Elburton" },
      { route: "2", dest: "City Centre / Mount Batten", via: "Plymstock" },
      { route: "21/21A", dest: "City Centre", via: "Laira Bridge" },
    ],
  },
  {
    match: ["derriford", "crownhill", "southway", "tamerton", "woolwell", "roborough", "glenholt", "george", "estover", "leigham"],
    services: [
      { route: "42/42A", dest: "City Centre / Southway", via: "Mannamead and Mutley" },
      { route: "42C", dest: "Woolwell / City Centre", via: "Derriford and Crownhill" },
      { route: "50/51", dest: "Derriford circular", via: "Estover and Marsh Mills" },
      { route: "41", dest: "City Centre / Southway", via: "Crownhill and Peverell" },
      { route: "28", dest: "George Junction / City Centre", via: "Derriford Hospital" },
    ],
  },
  {
    match: ["devonport", "st budeaux", "barne barton", "keyham", "milehouse", "ernesettle", "victoria road", "ford", "camels head", "weston mill", "saltash passage"],
    services: [
      { route: "21/21A", dest: "Plympton / Barne Barton", via: "Devonport and City Centre" },
      { route: "34/34A", dest: "Derriford / City Centre", via: "Milehouse and Stoke" },
      { route: "43/43A", dest: "City Centre / Ernesettle", via: "St Budeaux" },
      { route: "16/16A", dest: "City Centre / Kings Tamerton", via: "North Prospect" },
    ],
  },
  {
    match: ["whitleigh", "honicknowle", "west park", "tintagel", "thackeray", "transit way", "ham", "north prospect", "beacon park"],
    services: [
      { route: "44", dest: "City Centre / Whitleigh", via: "Crownhill and Mannamead" },
      { route: "61", dest: "Transit Way / City Centre", via: "West Park and Honicknowle" },
      { route: "50/51", dest: "Derriford circular", via: "Transit Way and Crownhill" },
      { route: "35/35A", dest: "City Centre / Ham", via: "Peverell and Mutley" },
    ],
  },
  {
    match: ["efford", "laira", "lipson", "mount gould", "prince rock", "greenbank", "cattedown", "beaumont", "tothill"],
    services: [
      { route: "8/9", dest: "City Centre / Efford", via: "Lipson Vale and Laira" },
      { route: "23/24", dest: "City Centre / Mount Gould", via: "Greenbank" },
      { route: "5/5A", dest: "City Centre / Elburton", via: "Prince Rock" },
      { route: "21/21A", dest: "Plympton / Barne Barton", via: "City Centre" },
    ],
  },
  {
    match: ["mutley", "mannamead", "peverell", "hyde park", "outland", "morrisons", "higher compton", "lower compton"],
    services: [
      { route: "42/42C", dest: "Derriford / City Centre", via: "Mannamead" },
      { route: "41", dest: "Southway / City Centre", via: "Peverell" },
      { route: "35/35A", dest: "Ham / City Centre", via: "Peverell" },
      { route: "28", dest: "George Junction / City Centre", via: "Crownhill" },
    ],
  },
  {
    match: ["torpoint", "cremyll", "cawsand", "millbrook", "antony", "whitsand", "saltash", "tamar"],
    services: [
      { route: "70/70A", dest: "Cremyll / Plymouth", via: "Torpoint Ferry" },
      { route: "10/10S", dest: "Looe / Plymouth", via: "Saltash" },
      { route: "11/11A", dest: "Liskeard / Plymouth", via: "Saltash" },
      { route: "12/12A", dest: "Callington / Plymouth", via: "Saltash" },
    ],
  },
];

const DEFAULT_SERVICES = [
  { route: "21/21A", dest: "City Centre", via: "main Plymouth corridor" },
  { route: "42", dest: "Derriford", via: "City Centre" },
  { route: "5/5A", dest: "Elburton", via: "City Centre" },
  { route: "50/51", dest: "Derriford circular", via: "Plymouth network" },
];

function hashString(value = "") {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function formatTime(minutesFromNow) {
  const date = new Date(Date.now() + minutesFromNow * 60000);
  return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}

export function getRouteHintsForStop(stop) {
  if (!stop) return DEFAULT_SERVICES;
  const haystack = [stop.name, stop.street, stop.locality, stop.id].filter(Boolean).join(" ").toLowerCase();
  const found = ROUTE_PATTERNS.find((pattern) => pattern.match.some((term) => haystack.includes(term)));
  return found?.services || DEFAULT_SERVICES;
}

export function makeDemoDepartures(stop) {
  const services = getRouteHintsForStop(stop);
  const seed = hashString(`${stop?.id || "stop"}-${stop?.name || ""}`);
  const base = 2 + (seed % 5);

  return services.slice(0, 5).map((service, index) => {
    const mins = base + index * 7 + ((seed >> (index + 1)) % 4);
    return {
      ...service,
      time: formatTime(mins),
      mins,
      source: "demo",
    };
  });
}
